module.exports = __webpack_public_path__ + "img/up_arrow.cb672e3d.svg";